import React from 'react';
import { Server } from 'lucide-react';

const SocialIcon = ({ icon, onClick }) => (
  <button onClick={onClick} className="text-gray-400 hover:text-purple-400 transition-colors" aria-label="Link de rede social">{icon}</button>
);

const FooterLink = ({ children, onClick }) => (
  <button onClick={onClick} className="text-gray-400 hover:text-purple-400 transition-colors text-left">{children}</button>
);

export default function Footer() {
  const handleSocialClick = (network) => {
    window.open('https://' + network + '.com', '_blank');
  };
  return (
    <footer className="bg-gray-900 py-16 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center mb-6">
              <div className="mr-2 text-purple-500">
                <Server size={24} />
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-purple-400 to-indigo-400 text-transparent bg-clip-text">Hostul</span>
            </div>
            <p className="text-gray-400 mb-6">Hospedagem de qualidade com foco em desempenho, segurança e facilidade de uso.</p>
            <div className="flex space-x-4">
              <SocialIcon icon={<svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"></path></svg>} onClick={() => handleSocialClick('facebook')} />
              <SocialIcon icon={<svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15h-2v-6h2v6zm-1-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 7h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3h-2v-6h2v1.1c.52-.62 1.45-1.1 2.5-1.1 1.93 0 3.5 1.57 3.5 3.5v2.5z"></path></svg>} onClick={() => handleSocialClick('linkedin')} />
              <SocialIcon icon={<svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path></svg>} onClick={() => handleSocialClick('twitter')} />
            </div>
          </div>
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Empresa</h3>
            <ul className="space-y-4">
              <FooterLink onClick={() => {}}>Sobre nós</FooterLink>
              <FooterLink onClick={() => {}}>Blog</FooterLink>
              <FooterLink onClick={() => {}}>Carreiras</FooterLink>
              <FooterLink onClick={() => {}}>Parceiros</FooterLink>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Suporte</h3>
            <ul className="space-y-4">
              <FooterLink onClick={() => {}}>Central de Ajuda</FooterLink>
              <FooterLink onClick={() => {}}>Base de Conhecimento</FooterLink>
              <FooterLink onClick={() => {}}>Status do Sistema</FooterLink>
              <FooterLink onClick={() => {}}>Contato</FooterLink>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Recursos</h3>
            <ul className="space-y-4">
              <FooterLink onClick={() => {}}>Documentação</FooterLink>
              <FooterLink onClick={() => {}}>API</FooterLink>
              <FooterLink onClick={() => {}}>Parcerias</FooterLink>
              <FooterLink onClick={() => {}}>Afiliados</FooterLink>
            </ul>
          </div>
        </div>
        
        {/* Seção Minimalista de Termos e Políticas */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="text-center mb-4">
            <p className="text-gray-500 text-xs uppercase tracking-wide">Termos e Políticas</p>
          </div>
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <FooterLink onClick={() => window.location.href = '/legal/termosdeservico/#termos-politicas'}>Termos de Serviço</FooterLink>
            <FooterLink onClick={() => window.location.href = '/legal/contratodehospedagem/#termos-politicas'}>Contrato de Hospedagem</FooterLink>
            <FooterLink onClick={() => window.location.href = '/legal/politicadeprivacidade/#termos-politicas'}>Política de Privacidade</FooterLink>
            <FooterLink onClick={() => window.location.href = '/legal/politicadereembolso/#termos-politicas'}>Política de Reembolso</FooterLink>
            <FooterLink onClick={() => window.location.href = '/legal/politicadeusoaceitavel/#termos-politicas'}>Uso Aceitável</FooterLink>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-500">
          <p>&copy; 2026 Hostul. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
} 